exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".header{height:6.4rem;padding:1.5rem 13rem 1.5rem 5rem;position:absolute;top:4.5rem;left:0;z-index:10;background-color:var(--dark-gray);transform:translate3d(-100%,0,0);backface-visibility:hidden;animation:header-slide-in .5s linear forwards .5s}@media (max-width:991px){.header{width:100%;height:auto;padding-top:1rem;padding-bottom:1rem;top:0}}@media (max-width:767px){.header{padding-left:3rem;padding-right:5rem}}@keyframes header-slide-in{0%{transform:translate3d(-100%,0,0)}to{transform:translateZ(0)}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-d731ff84","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Header.vue
// module id = 29
// module chunks = 0